import React, { useState } from "react";
import {
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function ListComponent({
  text,
  children,
  startIcon = false,
  endIcon = false,
  iconColor,listItemButtonStyle,
  textStyle,
  sx
}) {
  const [openList, setOpenList] = useState(false);

  const handleClick = () => {
    setOpenList(!openList);
  };

  return (
    <List
      sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper", ...sx }}
      component="nav"
    >
      <ListItemButton sx={{ padding: "0" , ...listItemButtonStyle}} onClick={handleClick}>
        {startIcon ? (
          openList ? (
            <KeyboardArrowDownIcon
              sx={{
                color: iconColor,
                width: "24px",
                height: "24px",
              }}
            />
          ) : (
            <KeyboardArrowRightIcon
              sx={{
                color: iconColor,
                width: "24px",
                height: "24px",
              }}
            />
          )
        ) : (
          ""
        )}
        <ListItemText
          primary={
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                color: "text.primary",
                display: "flex",
                alignItem: "center",
              }}
              variant="subtitle2"
            >
              {text}
              {endIcon ? (
                openList ? (
                  <KeyboardArrowUpIcon
                    sx={{
                      color: iconColor,
                      width: "24px",
                      height: "24px",
                    }}
                  />
                ) : (
                  <KeyboardArrowDownIcon
                    sx={{
                      color: iconColor,
                      width: "24px",
                      height: "24px",
                    }}
                  />
                )
              ) : (
                ""
              )}
            </Typography>
          }
        />
      </ListItemButton>
      <Collapse in={openList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </List>
  );
}

export default ListComponent;
